import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Logo from "../components/Logo";
import ThemeToggle from "../components/ThemeToggle";
import PublicNav from "../components/PublicNav";

export default function About() {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-brand-dark-bg text-gray-900 dark:text-gray-100">
      {/* Nav */}
      <PublicNav />

      <main className="flex-1 max-w-3xl mx-auto px-6 py-16 w-full">
        {/* Logo + phonetic statement */}
        <section className="mb-16 text-center">
          <div className="flex justify-center mb-6">
            <Logo className="h-16" />
          </div>
          <p className="text-2xl font-light text-gray-400 dark:text-gray-500 tracking-widest mb-1 font-mono">
            /dʒɑb.ˈɔː.ɹɪ.ɡoʊ/
          </p>
          <p className="text-base font-semibold text-gray-900 dark:text-white tracking-[0.2em] uppercase mb-2">
            job · OR · i · go
          </p>
          <p className="text-sm text-gray-400 italic">
            From Latin{" "}
            <span className="font-medium text-brand-violet dark:text-brand-violet-on-dark">origo</span> —
            origin, source, beginning. Where your career story starts.
          </p>
        </section>

        <div className="border-t border-gray-100 dark:border-white/10 mb-16" />

        {/* Mission */}
        <section className="mb-16">
          <p className="text-sm font-medium text-brand-violet dark:text-brand-violet-on-dark mb-3 uppercase tracking-widest">
            Our mission
          </p>
          <h1 className="text-4xl font-extrabold mb-6 leading-tight">
            Recruitment,
            <br />
            with the loop closed.
          </h1>
          <p className="text-gray-500 dark:text-gray-400 text-lg leading-relaxed mb-4">
            Recruitment is a three-party coordination problem. When one party
            goes silent, the other two lose context. Candidates assume
            rejection. Agencies lose visibility into their own pipelines.
            Employers receive shortlists that have stopped being current. The
            same broken loop produces three different experiences.
          </p>
          <p className="text-gray-500 dark:text-gray-400 text-lg leading-relaxed mb-4">
            Joborigo is the substrate that connects those three parties without
            inserting itself between them. Agencies own their candidate
            relationships. Employers see real shortlists, not noise. Seekers see
            honest status, not silence. Status flows where it should; nothing
            else does.
          </p>
          <p className="text-gray-500 dark:text-gray-400 text-lg leading-relaxed">
            No ads. No candidate data sales. No AI cover letters. No fake
            signal. Just the loop, working as it should.
          </p>
        </section>

        <div className="border-t border-gray-100 dark:border-white/10 mb-16" />

        {/* Team */}
        <section className="mb-16">
          <p className="text-sm font-medium text-brand-violet dark:text-brand-violet-on-dark mb-3 uppercase tracking-widest">
            Team
          </p>
          <h2 className="text-2xl font-bold mb-4">
            Built by someone who's been there
          </h2>
          <p className="text-gray-500 dark:text-gray-400 text-lg leading-relaxed">
            Joborigo is an independent product, built with care by a solo
            founder alongside a full-time role. Every feature exists because it
            was genuinely needed and not because a roadmap committee approved it.
          </p>
        </section>

        {/* CTA */}
        <div className="rounded-2xl bg-brand-violet p-px">
          <div className="rounded-2xl bg-white dark:bg-brand-dark-surface px-8 py-10 text-center">
            <h2 className="text-2xl font-bold mb-2">Ready to get organised?</h2>
            <p className="text-gray-500 dark:text-gray-400 mb-6">
              It's free to get started. No credit card required.
            </p>
            <Link
              to="/register"
              className="inline-block bg-brand-violet text-white px-8 py-3 rounded-lg font-medium hover:opacity-90 transition"
            >
              Create your free account
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
